export default __webpack_public_path__ + "static/media/spr-design-system-dark.fb054113.png";